'use client';

import { useCallback, useEffect, useState } from 'react';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';

const RecaptchaV3 = ({ setValue }) => {
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const onVerify = useCallback((token) => {
    setRecaptchaToken(token);
  }, []);

  useEffect(() => {
    setRefreshReCaptcha((r) => !r);
  }, []);
  useEffect(() => {
    setValue('captcha', recaptchaToken);
  }, [recaptchaToken]);
  return (
    <div className="w-full flex justify-center">
      <GoogleReCaptcha onVerify={onVerify} refreshReCaptcha={refreshReCaptcha} />
    </div>
  );
};

export default RecaptchaV3;
